import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-test-buttons',
  templateUrl: './test-buttons.component.html',
  styleUrls: ['./test-buttons.component.scss']
})
export class TestButtonsComponent
{
  public modalOpened = false;
  public windowOpened = false;
}
